export default __webpack_public_path__ + "static/media/TrainingScreenDescriptionThumbnail.6f1aa01b.png";